const Page404 = () => {
  return (
    <div>
      <div className=" fixed left-1/2 -translate-y-1/2 top-1/2 -translate-x-1/2 flex flex-col items-center">
        <div className=" text-[24rem] -tracking-wides font-Bold text-main">
          404
        </div>
        <div className=" text-5xl text-main">
          Üzgünüz sayfa yüklenirken bir sorunla karşılaştık...
        </div>
      </div>
    </div>
  );
};

export default Page404;
